import { useQuery } from 'react-query';
import { fetchSectionBanners } from '@api/common';
import Banner, { BannerSize } from '@components/common/Banner';

const CurationBanner = ({ sectionId }: { sectionId: number }) => {
  const { data } = useQuery(['sectionBanner', sectionId], () =>
    fetchSectionBanners(sectionId)
  );

  if (!data) {
    return null;
  }

  return (
    <Banner name="section-banner" size={BannerSize.curation} items={data} />
  );
};

export default CurationBanner;
